import dynamic from 'next/dynamic';
import { GraphQLErrorProps } from './GraphQLErrorMessage.types';

export const GraphQLErrorMessage = dynamic<GraphQLErrorProps>(() =>
  import('./GraphQLErrorMessage').then(module => module)
);
